import { render, staticRenderFns } from "./Ocheck.vue?vue&type=template&id=5422aec6&scoped=true"
import script from "./Ocheck.vue?vue&type=script&lang=js"
export * from "./Ocheck.vue?vue&type=script&lang=js"
import style0 from "./Ocheck.vue?vue&type=style&index=0&id=5422aec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422aec6",
  null
  
)

export default component.exports